// extracted by mini-css-extract-plugin
module.exports = {"info":"styles_info__1e4SU","infoTitle":"styles_infoTitle__2stfG","infoText":"styles_infoText__2xFhs"};